






































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ImageModal from "@/components/ImageModal.vue";
import UgcsApi from "@/services/Ugcs";
import CategoriesApi from "@/services/CategoriesApi";
import MaterialGroupApi from "@/services/MaterialGroups";
import MaterialApi from "@/services/Materials";
import ConversationsApi from "@/services/Conversations";
import MessagesApi from "@/services/Messages";
import AuthModule from "@/store/auth";
import {
  Category,
  Material,
  MaterialGroup,
  MaterialGroupList,
  NewConversations,
  NewMessages,
  UGC,
  User,
} from "@/api/lab-base-api-client";
import { io } from "socket.io-client";
import { ValidationObserver } from "vee-validate";
import axios from "axios";
import logger from "@/lib/log/logger";

@Component({
  components: {
    ImageModal,
  },
})
export default class ChatTemplate extends Vue {
  private form: { material: string; text: string; imgs: File[]; zip: File | null } = {
    material: "",
    text: "",
    imgs: [],
    zip: null,
  };

  private messageForm: NewMessages = {
    conversationUuid: "",
    senderUuid: "",
    text: "",
  };

  private conversationForm: NewConversations = {
    userUuid: "",
    adminUuid: "",
  };

  // private adminUuid = process.env.VUE_APP_ADMIN_UUID_FOR_REPLY ? process.env.VUE_APP_ADMIN_UUID_FOR_REPLY : "";
  private adminUuid = process.env.VUE_APP_ADMIN_UUID_FOR_REPLY ? process.env.VUE_APP_ADMIN_UUID_FOR_REPLY : "";

  private UGCs: UGC[] = [];

  // selectのcategoryデータ配列
  private categories: Category[] = [];

  // selectのmaterialGroupデータ配列
  private materialGroups: MaterialGroupList[] = [];

  // selectのmaterialデータ配列
  private materials: Material[] = [];

  private category: Category | null = null;

  private materialGroup: MaterialGroup | null = null;

  private material = "";

  private isChatImgModal = false;

  private src: string | null = null;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  private async mounted() {
    this.fetchConversation();
    await this.setCategories();
    // UContentだった場合は質問教材をデフォルトで入力
    if (this.$route.name === "UContent") {
      const materialRes = await MaterialApi.instance.getMaterialByUuid(String(this.$route.query.material));
      const { material } = materialRes.data.data;
      const materialGroup = material?.materialGroup[0];
      const category = material?.materialGroup[0].categories[0];
      if (category) {
        this.category = category;
        this.setMaterialGroups(this.category);
      }
      if (materialGroup) {
        this.materialGroup = materialGroup;
        this.setMaterials(this.materialGroup);
      }
      if (material) {
        this.material = material.title;
      }
    }
  }

  // 画像モーダルの表示
  private async openImgModal(event: Event) {
    if (!event) {
      return;
    }
    this.isChatImgModal = true;
    this.src = (event?.target as HTMLImageElement).src;
  }

  // categoryを取得しセット
  private async setCategories() {
    const CategoriesRes = await CategoriesApi.instance.getCategories();
    this.categories = CategoriesRes.data.data.categories;
  }

  // categoryを選択した時実行、materialGroupを取得しセット
  private async setMaterialGroups(category: Category) {
    this.materialGroups = [];
    this.materials = [];
    this.materialGroup = null;
    this.material = "";

    const materialGroupRes = await MaterialGroupApi.instance.getMaterialGroup();
    const materialGroups = materialGroupRes.data.data.items.filter(
      (materialGroup: { categories: {} }) => materialGroup.categories
    );

    materialGroups.sort((a, b) => {
      if (a.createdAt > b.createdAt) {
        return 1;
      }
      return -1;
    });

    materialGroups.forEach((materialGroup: MaterialGroupList) => {
      // カテゴリ-の数分回す
      for (let i = 0; i < materialGroup.categories.length; i += 1) {
        if (materialGroup.categories[i].id === category.id) {
          this.materialGroups.push(materialGroup);
        }
      }
    });
  }

  // materialGroupを選択した時実行、materialを取得しセット
  private async setMaterials(materialGroup: MaterialGroup) {
    this.material = "";
    if (materialGroup.uuid) {
      const materialsRes = await MaterialApi.instance.getMaterialByRemoveDeleted(materialGroup.uuid);

      const materials = materialsRes.data.data.material;
      if (!materials) {
        return;
      }
      this.materials = materials.sort((a, b) => {
        if (a.sort > b.sort) {
          return 1;
        }
        return -1;
      });
    }
  }

  // ダイアログを閉じる
  private closeDialog() {
    this.$emit("close-dialog", false);
    this.form = {
      material: "",
      text: "",
      imgs: [],
      zip: null,
    };
    this.UGCs = [];
    this.materialGroups = [];
    this.materials = [];
    this.category = null;
    this.materialGroup = null;
    this.material = "";

    // バリデーションリセット
    (this.$refs.observer as InstanceType<typeof ValidationObserver>).reset();
  }

  // 画像をアップロード
  private async upImgs(value: File[]) {
    value.forEach(async (v: File) => {
      const ugc = await this.createUgc(v);
      this.UGCs.push(ugc);
    });
  }

  // UGCsの変更を検知して画像のvalidateを動かす
  @Watch("UGCs")
  private checkImgValidation() {
    (this.$refs.imgValidation as InstanceType<typeof ValidationObserver>).validate();
  }

  // UGCの中身から対応した情報を削除することでUGCモーダルのclose機能を実装
  private async closeUgcModal(i: number) {
    this.UGCs.splice(i, 1);
    if (this.form.imgs) {
      this.form.imgs = [];
    }
  }

  private async fetchConversation() {
    if (this.me) {
      const conversationsRes = await ConversationsApi.instance.getConversationByUserUuid(this.me.uuid);
      const conversation = conversationsRes.data.data.items;

      if (conversation.length) {
        this.messageForm.conversationUuid = conversation[0].uuid;
      } else {
        this.conversationForm.userUuid = this.me.uuid;
        this.conversationForm.adminUuid = this.adminUuid;

        if (this.me.roleId === 4 && "organizationUuid" in this.me) {
          this.conversationForm.organizationUuid = this.me.organizationUuid;
        }

        const createConversationRes = await ConversationsApi.instance.createConversations(this.conversationForm);

        if (createConversationRes.data.data.conversation) {
          this.messageForm.conversationUuid = createConversationRes.data.data.conversation.uuid;
        }
      }
    }
  }

  //  socket.io設定
  private socket = io(
    `${process.env?.NODE_ENV === "development" ? "http://localhost:3000" : process.env.VUE_APP_SOCKET_URL}`,
    {
      withCredentials: true,
      path: `${process.env?.NODE_ENV === "development" ? "" : "/api/socket.io"}`,
    }
  );

  // 送信
  private async submit() {
    if (!this.me) {
      return;
    }
    this.messageForm.senderUuid = this.me.uuid;

    // text内のlinkを検出し変換
    const regexpUrl = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
    const regexpMakeLink = (url: string) => {
      return `<a class="link" href="${url}">${url}</a>`;
    };
    this.form.text = this.form.text.replace(regexpUrl, regexpMakeLink);

    if (this.category && this.materialGroup) {
      this.form.material = `${this.category.name}/${this.materialGroup.name}/${this.material}`;
    }
    this.messageForm.text = `質問のある教材\n${this.form.material}\n\n質問内容\n${this.form.text}`;

    let files = "";
    this.UGCs.forEach(ugc => {
      files += `<img src="${ugc.url}" class="chat-img">`;
    });

    if (this.form.zip) {
      const zip = await this.createUgc(this.form.zip);
      files += `<div class="file-wrap download" data-ugc-uuid="${zip.uuid}"><i class="v-icon file-icon fa fa-solid fa-file-download"></i><div class="file-name">${zip.metadata.originalname}</div></div>`;
    }

    this.messageForm.text += `<div class="files mt-3">${files}</div>`;

    if (this.messageForm.text) {
      await MessagesApi.instance.postMessage(this.messageForm);
    }

    this.socket.emit("sendMessage", this.messageForm.conversationUuid);
    this.closeDialog();
    this.submitSlackNotice(this.me);
  }

  // slackへ通知
  private async submitSlackNotice(user: User) {
    const channel = process.env.NODE_ENV === "production" ? "#チャット通知" : "#notice-dev";
    const text = `${user.name}さんからメッセージが送信されました`;
    const params = new URLSearchParams();
    params.append("token", "xoxb-3051803435092-3476235718992-NViZmlLmPhPeVVLjJy1mD7lc");
    params.append("channel", channel);
    params.append("text", text);

    await axios.post("https://slack.com/api/chat.postMessage", params);
  }

  // UGC作成
  private async createUgc(file: File) {
    try {
      const ugcRes = await UgcsApi.instance.createUGC(file);
      if (ugcRes.data.data?.ugc?.uuid === undefined) {
        logger.frontError("failed create ugc");
        throw new Error("failed create ugc");
      }
      return ugcRes.data.data.ugc;
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
      throw err;
    }
  }
}
